import getIn from 'transmute/getIn';
import { useGetDataProperty } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataProperty';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DataSourcePropertyName = ({
  token
}) => {
  const {
    prefix,
    property
  } = getTokenParts(token);
  let dataPropertyName = '';
  const {
    data,
    loading,
    error
  } = useGetDataProperty({
    prefix,
    property
  });
  if (loading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      "data-test-id": "skeleton-loader-data-source-property-name"
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(MissingLabel, {
      type: "property"
    });
  }
  if (data) {
    dataPropertyName = getIn(['dataSourceProperty', 'label'], data);
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: dataPropertyName
  });
};
export default DataSourcePropertyName;